import { render, staticRenderFns } from "./HeadNav.vue?vue&type=template&id=1b70f85f&scoped=true"
import script from "./HeadNav.vue?vue&type=script&lang=js"
export * from "./HeadNav.vue?vue&type=script&lang=js"
import style0 from "./HeadNav.vue?vue&type=style&index=0&id=1b70f85f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70f85f",
  null
  
)

export default component.exports